import styled from 'styled-components'
import { FontSize1, NolKoma7toNolKoma8 } from "../../GlobalStyles";

export const ListSContainer = styled.div`
    /* background-color: red; */
    margin-top: 2.5rem;
`
export const TopTitle = styled.div`
    text-align: center;
    p {
        text-transform: uppercase;
        font-size: ${NolKoma7toNolKoma8};
        margin-bottom: 1rem;
    }
    h3 {
        text-transform: uppercase;
        font-size: ${FontSize1};
        letter-spacing: 4px;
    }
`
export const CollectionWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem 1rem;
    padding: 2.5rem 1rem;
    max-width: 1300px;
    margin: 0 auto;
    @media (min-width: 650px) {
        grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 900px) {
        grid-template-columns: repeat(4, 1fr);
    }
    @media (min-width: 1100px) {
        gap: 3rem 2rem;
    }
`